import { render, staticRenderFns } from "./AddItemWidget.vue?vue&type=template&id=5aa3bf92&"
import script from "./AddItemWidget.vue?vue&type=script&lang=js&"
export * from "./AddItemWidget.vue?vue&type=script&lang=js&"
import style0 from "./AddItemWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports